/**
 * The "AI task" issue template. GitLab CE has no group or instance templates, so instead of a file in every project
 * the app's New issue button puts the template into GitLab's new-issue form itself (issue[description] in the URL).
 * Keep it in step with .gitlab/issue_templates/AI task.md, which only issues started inside GitLab use.
 */
export const AI_TASK_TEMPLATE = `<!--
  AI task. When it is ready, assign it to an AI developer (rv_dev for Claude, rv_kimi_dev for Kimi) or to a person.
  The AI starts only when the goal and at least one acceptance criterion are filled in; otherwise it asks.
  Text between these comment marks is not shown and is not read as part of the task.
-->

### Goal
<!-- What should change, where (page, endpoint, app), and why. One or two sentences. -->


### Acceptance criteria
<!--
  One checkable line each: what a person or QA can see or test on the review link.
  Example: - [ ] the footer of every page shows the version from package.json, e.g. "v1.4.0"
-->
- [ ]
- [ ]

### How to test
<!-- Optional: the steps to see it, test data, which account or page. -->


### Notes
<!-- Optional: links, screenshots, constraints, related issues. -->
`;

/** GitLab's new-issue form of a project (its web URL), with the AI task template filled in */
export function newIssueUrl(projectUrl: string): string {
  return `${projectUrl}/-/issues/new?${new URLSearchParams({ 'issue[description]': AI_TASK_TEMPLATE })}`;
}
